import React from 'react'
import {
  List, Datagrid, TextField, EditButton, Create, SimpleForm, SelectInput, Filter,
  TextInput, NumberInput, Edit, SelectField, ReferenceField, ReferenceInput, FunctionField,
  RadioButtonGroupInput, ReferenceArrayInput, SelectArrayInput
} from 'admin-on-rest'
import { DependentInput } from 'aor-dependent-input'
import MonetaryField from '../components/monetaryField'
import AddBalanceButton from '../components/addBalanceButton'
import RecoverUserButton from '../components/recoverUserButton'

const isUser = (value) => value === '5a282dffc0844f13cb8a7be7'
const isGasStation = (value) => value === '5a282dffc0844f13cb8a7bea' || value === '5a282dffc0844f13cb8a7beb'
const isSuperAdminGasStation = (value) => value === '5b7ed25d4adf6bb06181f1ca'
const isOrganization = (value) => value === '5a282dffc0844f13cb8a7be8' || value === '5a282dffc0844f13cb8a7be9'
const isSuperAdminOrganization = (value) => value === '5b7ed2fd4adf6bb06181f1d6'
const hasTransactionPermission = (value) => isUser(value) || isOrganization(value) || isSuperAdminOrganization(value)

const validateUsers = (values) => {
  const errors = {}
  if (isGasStation && !values._gasStation) {
    errors._gasStation = ['O Posto é obrigatório!']
  }
  if (isOrganization && !values._organization) {
    errors._organization = ['A Empresa é obrigatória!']
  }
  if (hasTransactionPermission && !values.authenticateTransaction) {
    errors.authenticateTransaction = ['A Empresa é obrigatória!']
  }
  if (hasTransactionPermission && !values.balance) {
    errors.balance = ['O Saldo é obrigatório!']
  }
  if (!values.role) {
    errors.role = ['O Papel é obrigatório!']
  }
  if (!values.firstName) {
    errors.firstName = ['O Nome é obrigatório!']
  }
  if (!values.lastName) {
    errors.lastName = ['O Sobrenome é obrigatório!']
  }
  if (!values.identifier) {
    errors.identifier = ['O CPF é obrigatório!']
  }
  if (!values.email) {
    errors.email = ['O Email é obrigatório!']
  }
  if (!values.password) {
    errors.password = ['A Senha é obrigatória!']
  }
  if (values.authenticateTransaction) {
    values.authenticateTransaction = values.authenticateTransaction.toString()
  }
  return errors
}

const OrganizationFilter = (props) => (
  <Filter {...props}>
    <ReferenceInput label='Empresa' source='_organization' reference='organization' perPage={400} allowEmpty>
      <SelectInput optionText='name' />
    </ReferenceInput>
    <ReferenceInput label='Posto' source='_gasStation' reference='gasStation' perPage={400} allowEmpty>
      <SelectInput optionText='name' />
    </ReferenceInput>
  </Filter>
)

export const UserList = (props) => (
  <List {...props} title='Usuários' filters={<OrganizationFilter />}>
    <Datagrid>
      <ReferenceField source='role' reference='role' label='Papel' linkType={false}>
        <TextField label='Nome' source='name' />
      </ReferenceField>
      <FunctionField label='Nome' source='firstName' render={record => `${record.firstName} ${record.lastName}`} />
      <TextField label='CPF' source='identifier' />
      <TextField label='e-Mail' source='email' />
      <MonetaryField label='Saldo' source='balance' />
      <SelectField source='status' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'}
      ]}
      />
      <AddBalanceButton resource='user' />
      <EditButton />
    </Datagrid>
  </List>
)

export const DeletedUserList = (props) => (
  <List {...props} title='Usuários Excluídos'>
    <Datagrid>
      <FunctionField label='Nome' source='firstName' render={record => `${record.firstName} ${record.lastName}`} />
      <TextField label='CPF' source='identifier' />
      <TextField label='e-Mail' source='email' />
      <RecoverUserButton />
    </Datagrid>
  </List>
)

export const UserCreate = (props) => (
  <Create {...props} title='Criar Usuário'>
    <SimpleForm validate={validateUsers}>
      <SelectInput source='status' label='Status' defaultValue='active' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'}
      ]}
      />
      <ReferenceInput source='role' reference='role' label='Papel' allowEmpty>
        <SelectInput optionText='name' optionValue='_id' />
      </ReferenceInput>
      <DependentInput dependsOn='role' resolve={isGasStation}>
        <ReferenceInput source='_gasStation' reference='gasStation' label='Posto' perPage={400} allowEmpty>
          <SelectInput optionText='name' optionValue='_id' />
        </ReferenceInput>
      </DependentInput>
      <DependentInput dependsOn='role' resolve={isSuperAdminGasStation}>
        <ReferenceArrayInput label='Postos' reference='gasStation' source='_gasStationList' perPage={400}>
          <SelectArrayInput optionText='name' optionValue='_id' />
        </ReferenceArrayInput>
      </DependentInput>
      <DependentInput dependsOn='role' resolve={isOrganization}>
        <ReferenceInput source='_organization' reference='organization' label='Empresa' perPage={400} allowEmpty>
          <SelectInput optionText='name' optionValue='_id' />
        </ReferenceInput>
        <RadioButtonGroupInput label="Categoria" source="category" choices={[
          { id: 'employee', name: 'Funcionário' },
          { id: 'contractor', name: 'Benefício' }
        ]} />
      </DependentInput>
      <DependentInput dependsOn='role' resolve={isSuperAdminOrganization}>
        <ReferenceArrayInput label='Empresas' reference='organization' source='_organizationList' perPage={400}>
          <SelectArrayInput optionText='name' optionValue='_id' />
        </ReferenceArrayInput>
      </DependentInput>
      <TextInput label='Nome' source='firstName' />
      <TextInput label='Sobrenome' source='lastName' />
      <TextInput label='CPF' source='identifier' />
      <TextInput label='e-Mail' source='email' />
      <TextInput label='Senha' source='password' />
      <DependentInput dependsOn='role' resolve={hasTransactionPermission}>
        <NumberInput label='Senha de Transação' source='authenticateTransaction' />
      </DependentInput>
      <DependentInput dependsOn='role' resolve={hasTransactionPermission}>
        <NumberInput label='Saldo' source='balance' />
      </DependentInput>
    </SimpleForm>
  </Create>
)

export const UserEdit = (props) => (
  <Edit {...props} title='Editar Usuário'>
    <SimpleForm validate={validateUsers}>
      <SelectInput source='status' label='Status' defaultValue='active' choices={[
        {id: 'active', name: 'Ativo'},
        {id: 'inactive', name: 'Inativo'},
        {id: 'deleted', name: 'Excluído'}
      ]}
      />
      <ReferenceInput source='role' reference='role' label='Papel'>
        <SelectInput optionText='name' optionValue='_id' />
      </ReferenceInput>
      <DependentInput dependsOn='role' resolve={isGasStation}>
        <ReferenceInput source='_gasStation' reference='gasStation' label='Posto' perPage={400} allowEmpty>
          <SelectInput optionText='name' optionValue='_id' />
        </ReferenceInput>
      </DependentInput>
      <DependentInput dependsOn='role' resolve={isSuperAdminGasStation}>
        <ReferenceArrayInput label='Postos' reference='gasStation' source='_gasStationList' perPage={400}>
          <SelectArrayInput optionText='name' optionValue='_id' />
        </ReferenceArrayInput>
      </DependentInput>
      <DependentInput dependsOn='role' resolve={isOrganization}>
        <ReferenceInput source='_organization' reference='organization' label='Empresa' perPage={400} allowEmpty>
          <SelectInput optionText='name' optionValue='_id' />
        </ReferenceInput>
        <RadioButtonGroupInput label="Categoria" source="category" choices={[
          { id: 'employee', name: 'Funcionário' },
          { id: 'contractor', name: 'Benefício' }
        ]} />
      </DependentInput>
      <DependentInput dependsOn='role' resolve={isSuperAdminOrganization}>
        <ReferenceArrayInput label='Empresas' reference='organization' source='_organizationList' perPage={400}>
          <SelectArrayInput optionText='name' optionValue='_id' />
        </ReferenceArrayInput>
      </DependentInput>
      <TextInput label='Nome' source='firstName' />
      <TextInput label='Sobrenome' source='lastName' />
      <TextInput label='CPF' source='identifier' />
      <TextInput label='e-Mail' source='email' />
      <DependentInput dependsOn='role' resolve={hasTransactionPermission}>
        <NumberInput label='Senha de Transação' source='authenticateTransaction' />
      </DependentInput>
      <DependentInput dependsOn='role' resolve={hasTransactionPermission}>
        <NumberInput label='Saldo' source='balance' />
      </DependentInput>
    </SimpleForm>
  </Edit>
)



// WEBPACK FOOTER //
// ./src/collections/users.js